import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuoteDetail } from '../../hooks/useQuoteDetail';
import { QuoteDetail } from '../../components/user/QuoteDetail';

export const QuoteDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const detailProps = useQuoteDetail(id!);

  return <QuoteDetail {...detailProps} />;
};
